import React from 'react';
import { TrendingUp, Users, Award } from 'lucide-react';
import { useLanguage } from '../../../context/LanguageContext';
import './Services.css';

const Services = () => {
  const { t } = useLanguage();

  const mainServices = [
    {
      icon: <TrendingUp className="h-12 w-12" />,
      title: t('services.main.trading.title'),
      description: t('services.main.trading.description')
    },
    {
      icon: <Users className="h-12 w-12" />,
      title: t('services.main.wealth.title'),
      description: t('services.main.wealth.description')
    },
    {
      icon: <Award className="h-12 w-12" />,
      title: t('services.main.familyOffice.title'),
      description: t('services.main.familyOffice.description')
    }
  ];

  const additionalServices = [
    {
      title: t('services.additional.assetManagement.title'),
      description: t('services.additional.assetManagement.description')
    },
    {
      title: t('services.additional.alternative.title'),
      description: t('services.additional.alternative.description')
    },
    {
      title: t('services.additional.insurance.title'),
      description: t('services.additional.insurance.description')
    },
    {
      title: t('services.additional.fundServices.title'),
      description: t('services.additional.fundServices.description')
    },
    {
      title: t('services.additional.corporate.title'),
      description: t('services.additional.corporate.description')
    },
    {
      title: t('services.additional.trust.title'),
      description: t('services.additional.trust.description')
    }
  ];

  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t('services.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('services.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {mainServices.map((service, idx) => (
            <div
              key={idx}
              className="bg-white p-8 rounded-xl shadow-lg hover:shadow-2xl transition-all transform hover:-translate-y-2 group border border-gray-100"
            >
              <div className="bg-brand-primary text-white p-4 rounded-lg inline-block mb-6 group-hover:scale-110 transition-transform shadow-lg">
                {service.icon}
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">{service.title}</h3>
              <p className="text-gray-600 leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>

        {/* Additional Services */}
        <div className="bg-gradient-to-br from-blue-50 to-white rounded-2xl p-8 md:p-12 shadow-lg border border-blue-100">
          <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">{t('services.additional.title')}</h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {additionalServices.map((service, idx) => (
              <div key={idx} className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-all border border-blue-100">
                <h4 className="text-lg font-bold text-gray-900 mb-3">{service.title}</h4>
                <p className="text-gray-600 text-sm leading-relaxed">{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
